import { Badge } from 'antd'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
// @ts-ignore
import Scrollchor from 'react-scrollchor'

import { DownCircleIcon, UpCircleIcon } from '../icons'
import { Layout } from '../layout'

import {
    Conversation as ConversationContent,
    ConversationProps,
    Header as ConversationHeader,
    HeaderProps,
    Footer as ConversationFooter,
    FooterProps
} from './components'

import * as styles from './Talk.module.less'

export interface OptionsProps {
    canBookmarkComment?: boolean
    canBookmarkConversationt?: boolean
    canDislike?: boolean
    canLike?: boolean
    isChronologicalOrder?: boolean
}

export type TalkProps = ConversationProps & {
    options?: typeof defaultProps
    bookmarkConversation: (conversationId: string) => void
    headless?: boolean
    setConversationAsRead: (isLastMessageRead: boolean) => void
    onGoToConversationsClick?: () => void
    tributes?: Array<any>
    talkRef: (ref: React.MutableRefObject<any>) => void
    onLinkClick?: (url: string) => void
    getTributeComponent: any
}

const defaultProps: OptionsProps = {
    canBookmarkComment: true,
    canBookmarkConversationt: true,
    canDislike: false,
    canLike: true,
    isChronologicalOrder: true
}

export const Talk: React.FC<TalkProps> = (props) => {
    const { getTributeComponent } = props
    const [talkTargetId] = useState(
        parseInt(Math.random().toString(8).substr(2, 9), 10).toString()
    )
    const talkRef = useRef(null)
    const goToRef = useRef(null)
    const goToBottomButtonRef = useRef(null)
    const goToTopButtonRef = useRef(null)
    const [goTo, setGoTo] = useState<() => void>()
    const [goToBottom, setGoToBottom] = useState<() => void>()
    const [goToTop, setGoToTop] = useState<() => void>()
    const [toCommentId, setToCommentId] = useState('')

    // Once Talk is loaded, go to the end of conversation if chronological order.
    useEffect(() => {
        talkRef.current &&
            goToBottom &&
            props?.options?.isChronologicalOrder &&
            goToBottom()
    }, [talkRef.current, goToBottom])

    useEffect(() => {
        // @ts-ignore
        goToRef.current && setGoTo(() => goToRef.current.simulateClick)
    }, [goToRef.current])

    useEffect(() => {
        // @ts-ignore
        goToBottomButtonRef.current &&
            setGoToBottom(() => {
                if (goToBottomButtonRef.current) {
                    // @ts-ignore
                    return goToBottomButtonRef.current?.simulateClick
                }
            })
    }, [goToBottomButtonRef.current])

    useEffect(() => {
        // @ts-ignore
        goToTopButtonRef.current &&
            setGoToBottom(() => {
                if (goToBottomButtonRef.current) {
                    // @ts-ignore
                    return goToBottomButtonRef.current?.simulateClick
                }
            })
    }, [goToTopButtonRef.current])

    const goToComment = (id: string) => {
        setToCommentId(id)
    }

    if (!props.conversation) {
        return <div>Conversation id not valid.</div>
    }
    const headerProps: HeaderProps = {
        bookmarkConversation: props.bookmarkConversation,
        conversation: props.conversation,
        onGoToConversationsClick: props.onGoToConversationsClick,
        user: props.user
    }

    const conversationProps: ConversationProps = {
        ...props
    }

    const footerProps: FooterProps = {
        conversationId: props.conversation ? props.conversation.id : '',
        getTributeComponent,
        goToComment,
        user: props.user,
        addComment: props.addComment,
        tributes: props.tributes
    }

    const onContentBottomReached = () => {
        props.setConversationAsRead(true)
    }
    const onContentTopReached = () => {}

    // @ts-ignore
    const hasUnreadMessages: boolean =
        props.conversation.unreadMessagesBy &&
        props.conversation.unreadMessagesBy.find(
            (u) => u.oauthId === props.user.id
        ) !== undefined

    const goToBottomButton = props.options?.isChronologicalOrder && (
        <Badge
            dot={hasUnreadMessages ? true : false}
            className={
                hasUnreadMessages
                    ? styles.unreadMessagesNotification
                    : styles.goToEndOfConversation
            }
        >
            <DownCircleIcon
                onClick={() => goToBottom && goToBottom()}
                style={{ fontSize: '2rem' }}
            />
        </Badge>
    )

    const goToTopButton = !props.options?.isChronologicalOrder && (
        <UpCircleIcon
            onClick={() => goToTop && goToTop()}
            style={{ fontSize: '2rem' }}
        />
    )

    useEffect(() => {
        if (toCommentId !== '' && goTo) {
            goTo()
        }
    })

    const headerContent = props.options?.isChronologicalOrder ? (
        !props.headless && <ConversationHeader {...headerProps} />
    ) : (
        <ConversationFooter {...footerProps} />
    )
    const footerContent = props.options?.isChronologicalOrder && (
        <ConversationFooter {...footerProps} />
    )

    return (
        <div className={styles.talk} ref={talkRef}>
            <Layout
                content={<ConversationContent {...conversationProps} />}
                footerContent={footerContent}
                goToBottomButton={goToBottomButton}
                goToTopButton={goToTopButton}
                headerContent={headerContent}
                onContentBottomReached={onContentBottomReached}
                onContentTopReached={onContentTopReached}
                target={talkTargetId}
            />
            <Scrollchor
                ref={goToBottomButtonRef}
                to="#lastComment"
                target={talkTargetId}
            />
            <Scrollchor
                ref={goToTopButtonRef}
                to="#top"
                target={talkTargetId}
            />
            <Scrollchor ref={goToRef} to={toCommentId} target={talkTargetId} />
        </div>
    )
}
